import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ReturnSetting } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface ReturnSettingsModel {
  returnSettingsMap: Record<string, ReturnSetting>;
  setReturnSettings: Action<ReturnSettingsModel, ReturnSetting[]>;
  setReturnSetting: Action<ReturnSettingsModel, ReturnSetting>;
  fetchReturnSettingsLoading: boolean;
  setFetchReturnSettingsLoading: Action<ReturnSettingsModel, boolean>;
  fetchReturnSettings: Thunk<ReturnSettingsModel, void, Injections, StoreModel, Promise<void>>;
  fetchReturnSettingsFailure: Action<ReturnSettingsModel, ApplicationErrorOptions>;
}

export const returnSettingsModel: ReturnSettingsModel = {
  returnSettingsMap: {},
  setReturnSettings: action((state, returnSettings) => {
    const returnSettingsMap = returnSettings.reduce<Record<string, ReturnSetting>>((acc, curr) => {
      acc[curr.returnsSettingsId] = curr;
      return acc;
    }, {});
    state.returnSettingsMap = returnSettingsMap;
  }),
  setReturnSetting: action((state, returnSetting) => {
    state.returnSettingsMap[returnSetting.returnsSettingsId] = returnSetting;
  }),
  fetchReturnSettingsLoading: false,
  setFetchReturnSettingsLoading: action((state, isLoading) => {
    state.fetchReturnSettingsLoading = isLoading;
  }),
  fetchReturnSettings: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchReturnSettingsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchReturnSettings();
      actions.setReturnSettings(response);
      actions.setFetchReturnSettingsLoading(false);
      return response;
    } catch (error) {
      actions.fetchReturnSettingsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchReturnSettingsLoading(false);
      return error;
    }
  }),
  fetchReturnSettingsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default returnSettingsModel;
